/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.17.0
 */

import { EGTMBasketSectionType } from '../../modules/analytics/GoogleTagManager/GTMOperations/GTMBasketOperations';
import { ELogBusinessEventName, ELogBusinessEventType } from '../../modules/logging';
import { ITableInitialise } from '../../modules/table/types';
import { ISubscriberTable } from './types';

export const TABLE_FILTER_AVAILABLE_NAMES: Array<keyof ISubscriberTable> = [
    'accessName',
    'account',
    'accountName',
    'assistantCampaignsCount',
    'balance',
    'cityNumber',
    'contractNumber',
    'coordinatorCampaignsCount',
    'dcRules',
    'icc',
    'inn',
    'kpp',
    'labels',
    'loyaltyStatus',
    'msisdn',
    'name',
    'numberType',
    'persDataLockDate',
    'persDataStatusName',
    'position',
    'ratePlan',
    'status',
    'subdivisionKpp',
    'subdivisionName',
    'zone',
    'eventTimeChangeCountry',
    'currCountryName',
];

export const SUBSCRIBERS_IN_ROAMING = 'subscribers-in-roaming';

export const API_SUBSCRIBER_TABLE_META = 'subscriber/mobile/meta';

export const API_SUBSCRIBER_TABLE_LIST = 'subscriber/mobile/list';

export const API_SUBSCRIBER_TABLE_FILTER_AND_SORT = 'subscriber/mobile/filter-and-sort';
export const API_SUBSCRIBER_TABLE_FILTER_SUGGEST = 'subscriber/mobile/suggest';
export const API_SUBSCRIBER_TABLE_FILTER_PRESET = 'subscriber/mobile/filter-and-sort-preset';

export const API_SUBSCRIBER_TABLE_CHECKBOX = 'subscriber/mobile/basket';
export const API_SUBSCRIBER_TABLE_BASKET_LIST = 'subscriber/mobile/basket/list';

export const API_SUBSCRIBER_TABLE_RESIZE = 'subscriber/mobile/fields/resize';

export const API_SUBSCRIBER_TABLE_COLUMN_SETTINGS = 'subscriber/mobile/fields';

export const API_SUBSCRIBER_TABLE_LABEL = 'subscriber/mobile/labels';


export const SUBSCRIBER_TABLE_CONFIG: ITableInitialise = {
    meta: {
        url: API_SUBSCRIBER_TABLE_META,
    },
    list: {
        url: API_SUBSCRIBER_TABLE_LIST,
        log: {
            eventName: ELogBusinessEventName.B2B_MOBILE_SUBSCRIBERS,
            type: ELogBusinessEventType.common,
        },
    },
    filterAndSort: {
        url: API_SUBSCRIBER_TABLE_FILTER_AND_SORT,
        suggest: API_SUBSCRIBER_TABLE_FILTER_SUGGEST,
        preset: API_SUBSCRIBER_TABLE_FILTER_PRESET,
    },
    basket: {
        checkbox: API_SUBSCRIBER_TABLE_CHECKBOX,
        list: API_SUBSCRIBER_TABLE_BASKET_LIST,
        gtm: {
            loadList: EGTMBasketSectionType.MOBILE,
        },
    },
    resize: {
        url: API_SUBSCRIBER_TABLE_RESIZE,
    },
    columnSettings: {
        url: API_SUBSCRIBER_TABLE_COLUMN_SETTINGS,
    },
    labels: {
        url: API_SUBSCRIBER_TABLE_LABEL,
        fieldName: 'labels',
    },
};
